export class RoleConstants {
  public static readonly ADMIN: string = '1000';
  public static readonly SUPER_USER: string = '1001';
  public static readonly USER: string = '1002';
  public static readonly MATRIX_PPA_ADMIN: string = '1003';
}

export const ROLE_GROUPS = {
  ANY_USER: [
    RoleConstants.USER,
    RoleConstants.ADMIN,
    RoleConstants.SUPER_USER,
    RoleConstants.MATRIX_PPA_ADMIN
  ],

  ADMIN_ROLES: [
    RoleConstants.ADMIN,
    RoleConstants.SUPER_USER,
    RoleConstants.MATRIX_PPA_ADMIN
  ],

  SUPER_USER: [
    RoleConstants.SUPER_USER,
    RoleConstants.MATRIX_PPA_ADMIN
  ],

  MATRIX_PPA_ADMIN_ONLY: [
    RoleConstants.MATRIX_PPA_ADMIN
  ]
};
